import { DepartureScheduleQueryParams } from "@interfaces/departure-schedule";
import { createContext, FC, ReactNode, useContext } from "react";

const context = createContext<DepartureScheduleQueryParams>({});

export const useDepartureScheduleParamsContext = () => useContext(context);

export const DepartureScheduleParamsProvider: FC<{
  value: DepartureScheduleQueryParams;
  children: ReactNode;
}> = ({ value, children }) => {
  return <context.Provider value={value}>{children}</context.Provider>;
};
